const imageGenerationLockEvent = 'xed21:image-generation-lock';

let activeCount = 0;

export interface ImageGenerationLockDetail {
  active: boolean;
  count: number;
}

export function setImageGenerationInProgress(active: boolean) {
  activeCount = Math.max(0, activeCount + (active ? 1 : -1));

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent<ImageGenerationLockDetail>(imageGenerationLockEvent, {
      detail: {
        active: activeCount > 0,
        count: activeCount,
      },
    }));
  }
}

export function getImageGenerationLockEventName() {
  return imageGenerationLockEvent;
}
